export const Urls = {
    APP: '/',
    DECISION_MANAGER: '/decisions',
    TEMPLATE_BUILDER: '/template/builder',
    CHOICE_SCORER: '/score/choice',
    CHOICE_SCORER_COMPARE: '/score/compare',
    CHOICE_SCORER_BINS: '/score/bins',
    RESULTS: '/score/results',
    WEIGHTING: '/weight',
    CHOICE_SUBMITTER: '/choice',
    CHOICE_CARDS: '/card',
    CHOICE_MANAGER: '/choices',
    LIST_MANAGER: '/lists',
    USERS: '/users',
    VIEWPOINT_MANAGER: '/viewpoint',
    APP_BUILD: '/app',
    APP_EMBED: '/app2',
    APP_SHARE: '/app/share',
    APP_LIBRARY: '/apps',
    INSIGHTS: '/insights',
    // APP_BUILD
    TEMPLATE_BUILDER_EMBED: '/app/template/builder',
    CHOICE_SCORER_EMBED: '/app/score/choice',
    CHOICE_SCORER_COMPARE_EMBED: '/app/score/compare',
    CHOICE_SCORER_BINS_EMBED: '/app/score/bins',
    RESULTS_EMBED: '/app/score/results',
    WEIGHTING_EMBED: '/app/weight',
    CHOICE_SUBMITTER_EMBED: '/app/choice',
    CHOICE_CARDS_EMBED: '/app/card',
    LIST_MANAGER_EMBED: 'app/lists',
    // APP_EMBED
    TEMPLATE_BUILDER_EMBED2: '/app2/template/builder',
    CHOICE_SCORER_EMBED2: '/app2/score/choice',
    CHOICE_SCORER_COMPARE_EMBED2: '/app2/score/compare',
    CHOICE_SCORER_BINS_EMBED2: '/app2/score/bins',
    RESULTS_EMBED2: '/app2/score/results',
    WEIGHTING_EMBED2: '/app2/weight',
    CHOICE_SUBMITTER_EMBED2: '/app2/choice',
    CHOICE_CARDS_EMBED2: '/app2/card',
    LIST_MANAGER_EMBED2: '/app2/lists',
    USERS_MANAGER_EMBED2: '/app2/users',
    VIEWPOINT_MANAGER_EMBED2: '/app2/viewpoint',
    CHOICE_MANAGER_EMBED2: '/app2/choices',
    GALLERY_EMBED2: '/app2/gallery',
    ACCESS_RESTRICTED_EMBED2: '/app2/restricted',
    // MARKETPLACE
    TEMPLATES: '/templates',
    MARKETPLACE: '/marketplace',
    //
    DECISION_UPLOAD: '/upload',
    ACCOUNTS_PREFIX: '/accounts',
    ACCOUNT: '/accounts/account',
    ACCOUNT_PROFILE: '/accounts/account/profile',
    ACCOUNT_MEMBERSHIP: '/accounts/account/membership',
    LOGIN: "/accounts/login",
    SIGNUP: "/accounts/signup",
    VERIFY_ACCOUNT: "/accounts/verify",
    RESET_PASSWORD: "/accounts/passwords/reset",
    CHANGE_PASSWORD: "/accounts/passwords/change",
    PRICING_PLANS: '/pricing/plans',
    CHECKOUT: '/accounts/products/checkout',
    CHECKOUT_SUCCESS: '/accounts/products/checkout/success',
    SHARE: '/share',
    JOIN_DECISION: '/decision/join',
    // EXTERNAL CLONING DECISION LINK 
    CLONING_DECISION: '/clone',
    MEMBERSHIP: '/members',
    DOMAIN: window.location.protocol + "//" + window.location.hostname + (window.location.port ? (':' + window.location.port) : ''),
    VIEWPOINT_HOSTED: 'https://viewpoint-ai.com/launch?' + encodeURIComponent('/?Viewpoint=is-awesome'),
    REDIRECT_TO_LOGIN: '/user/login',
    VIEWPOINT_LOGIN: 'https://viewpoint-ai.com/user/login',
    VIEWPOINT_REGISTER: 'https://viewpoint-ai.com/user/register'
}